import {
  FontFace,
  FontFaceFontWeightProperty,
  FontFaceFontStyleProperty,
} from "csstype";

import AauxNextRegularWoff2 from "./aauxnext-rg.woff2";
import AauxNextRegularItalicWoff2 from "./aauxnext-rgit.woff2";
import AauxNextMediumWoff2 from "./aauxnext-md.woff2";
import AauxNextMediumItalicWoff2 from "./aauxnext-mdit.woff2";
import AauxNextSemiBoldWoff2 from "./aauxnext-sm.woff2";
import AauxNextSemiBoldItalicWoff2 from "./aauxnext-smit.woff2";
import AauxNextBoldWoff2 from "./aauxnext-bd.woff2";
import AauxNextBoldItalicWoff2 from "./aauxnext-bdit.woff2";

interface WebfontConfig {
  name: string;
  // To understand these settings please see: https://developer.mozilla.org/en-US/docs/Web/CSS/font-weight
  weight: FontFaceFontWeightProperty;
  style: FontFaceFontStyleProperty;
  path: string;
}
const makeFontConfig: (settings: WebfontConfig) => FontFace = ({
  name,
  weight,
  style,
  path,
}) => {
  return {
    fontFamily: name,
    fontDisplay: "swap",
    fontStyle: style,
    fontWeight: weight,
    src: `
      url(${path}) format('woff2')
    `,
  };
};

export const AauxNextFonts = [
  // Regular
  makeFontConfig({
    name: "AauxNext",
    weight: 400,
    style: "normal",
    path: AauxNextRegularWoff2,
  }),
  makeFontConfig({
    name: "AauxNext",
    weight: 400,
    style: "italic",
    path: AauxNextRegularItalicWoff2,
  }),
  // Medium
  makeFontConfig({
    name: "AauxNext",
    weight: 500,
    style: "normal",
    path: AauxNextMediumWoff2,
  }),
  makeFontConfig({
    name: "AauxNext",
    weight: 500,
    style: "italic",
    path: AauxNextMediumItalicWoff2,
  }),
  // Semi Bold
  makeFontConfig({
    name: "AauxNext",
    weight: 600,
    style: "normal",
    path: AauxNextSemiBoldWoff2,
  }),
  makeFontConfig({
    name: "AauxNext",
    weight: 600,
    style: "italic",
    path: AauxNextSemiBoldItalicWoff2,
  }),
  // Bold
  makeFontConfig({
    name: "AauxNext",
    weight: 700,
    style: "normal",
    path: AauxNextBoldWoff2,
  }),
  makeFontConfig({
    name: "AauxNext",
    weight: 700,
    style: "italic",
    path: AauxNextBoldItalicWoff2,
  }),
];
